import HistoryPageNavbar from "@/components/ContentNavbar/HistoryPageNavbar/index";
import RequestDisplay from "@/components/RequestDisplay";
import { RequestDisplayLoadingShimmer } from "@/components/RequestDisplay/RequestDisplayLoadingShimmer";
import LoadingSpinner from "@/components/LoadingSpinner";
import { useRequest, useRequestBulk } from "@/queries";

/**
 * A request log rendered inside a Smart Table cell dialog using the same
 * RequestDisplay surface as the request detail page.
 */
export const MockRequestCellView = ({ requestId }: { requestId: string }) => {
  const requestPreview = useRequest(requestId);
  const requestBulk = useRequestBulk(requestId);

  if (requestPreview.isLoading) {
    return <RequestDisplayLoadingShimmer />;
  }

  if (!requestPreview.data) {
    return <p className="p-4 text-sm text-gray-500">Could not load this request log.</p>;
  }

  return (
    <div className="flex flex-col">
      <div className="shrink-0 border-b border-gray-200 bg-white">
        <HistoryPageNavbar requestId={requestId} requestInfo={requestPreview.data} compactTitle />
      </div>
      <div className="min-h-0 flex-1 overflow-hidden pt-4">
        {requestBulk.isLoading ? (
          <div className="flex justify-center py-8">
            <LoadingSpinner size={5} />
          </div>
        ) : (
          <RequestDisplay
            requestId={requestId}
            requestPreview={requestPreview.data}
            requestBulk={requestBulk.data}
          />
        )}
      </div>
    </div>
  );
};
